<mat-card appearance="raised">
  <mat-card-header>
    <mat-card-title>
      Owners
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <mat-accordion>
      <mat-expansion-panel class="mat-elevation-z0" *ngFor="let owner of owners; index as i">
        <mat-expansion-panel-header class="panel-header" collapsedHeight="auto" expandedHeight="auto">
          <mat-panel-title>
            <div fxLayout="row">
              <div class="index caption">
                {{i+1}}
              </div>
              <div fxLayout="column">
                <div (click)="$event.stopPropagation()">
                  <a [routerLink]="customerDetailsUri(owner)">
                    {{owner.firstName}} {{owner.lastName}}
                  </a>
                </div>
                <div (click)="$event.stopPropagation()">
                  <a class="caption" href="mailto:{{owner.email}}">{{owner.email}}</a>
                </div>
                <div class="mat-caption">{{owner.identityVerification.method | enumValueLabel : IdentityVerificationMethod : IdentityVerificationMethodLabel}} {{owner.identityVerification.status | enumValueLabel : IdentityVerificationStatus : IdentityVerificationStatusLabel}}</div>
                <div class="mat-caption" *ngIf="signatureCaptions[owner.id]">{{signatureCaptions[owner.id]}}</div>
              </div>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div fxLayout="column" class="expanded-list" fxLayoutGap="34px">
          <div fxLayout="column" class="expanded-list-item">
            <div *ngIf="owner.uniqueId">
              <a href="{{salesforceLink(owner.uniqueId)}}" target="_blank">{{owner.uniqueId}}</a>
            </div>
            <div *ngIf="!owner.uniqueId">-</div>
            <div class="mat-caption">Salesforce Owner ID</div>
          </div>

          <div fxLayout="column">
            <div>{{owner.ssn || '-'}}</div>
            <div class="mat-caption">SSN</div>
          </div>

          <div fxLayout="column">
            <div>{{(owner.updatedOn | date) || '-'}}</div>
            <div class="mat-caption">Updated on</div>
          </div>

          <div fxLayout="column">
            <div>{{(owner.createdOn | date) || '-'}}</div>
            <div class="mat-caption">Created on</div>
          </div>

        </div>

      </mat-expansion-panel>
    </mat-accordion>
  </mat-card-content>
</mat-card>